<div class="vcard">
    <div class="furtherInformations">
        <small>{{ 'fs.res.researchInfrastructure.view.researchInfrastructure' | hisUi }}
        | {{ capitalizeInitialLetter(researchInfrastructure.researchInfrastructureType.text) }}</small>
    </div>
    <h1>
        <ng-container>
            <his-translated-text [hisobject]="researchInfrastructure" hisAttribute="title"></his-translated-text><br/>
        </ng-container>        
    </h1>    
</div>